import React from 'react';
import {
  Button,
  Text,
  DataGrid,
  useResponsiveParams,
} from 'quanta-ui';
// import {
//   updateFireQuote,
//   updateFireQuoteUploadDocsVar,
// } from '../../_graphql/state';
import { updateFireQuote, updateFireQuoteUploadDocsVar, } from 'quanta-flows/modules/quote/fire/state';

export default function CustomerSummary({
  fireQuote,
  fireQuoteUploadDocs,
  goToStep,
  changeDisabled,
  loadingPremium,
  values,
  valuesAdditionalTabDetails,
  getDefaultClauses,
  getDefaultConditions,
  getDefaultExclusions,
  getDefaultWarranties,
  role,
}) {
  const isQuoteReadOnly =
    [
    'quote saved',
    'underwriter approved',
    'underwriter rejected',
    'converted to proposal',
    ]?.includes(fireQuote?.status?.toString()?.toLowerCase()) ||
    (role?.toString()?.toLowerCase() !== 'underwriter' &&
      fireQuote?.status?.toString()?.toLowerCase() ===
        'pending uw approval');
  const repeatTopDataForDesktop = 3;
  const repeatTopDataForMobile = 2;

  const repeat = useResponsiveParams({
    for_mobile: repeatTopDataForMobile,
    for_desktop: repeatTopDataForDesktop,
  });

  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });

  const customerSummaryData = [
    {
      label: 'Policy / Cover Type',
      text: `${fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value}`,
    },
    {
      label: 'Tenure',
      text: `${fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.tenure?.value} year(s)`,
    },
    {
      label: 'Policy Start Date',
      text: `${fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyStartDate}`,
    },
    {
      label: 'Basis of valuation',
      text: `${fireQuote?.basisOfValuation}`,
    },
    {
      label: 'Product',
      text: `${(fireQuote?.productName === 'Kotak Griha Raksha Plus' || fireQuote?.productKg === 'Kotak Griha Raksha Plus')
        ? 'Griha Raksha Plus' : 'Bharat Griha Raksha'}`, //productKg
    },
    fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
      ?.toString()
      ?.toLowerCase() !=  'home contents only' ?
    {
      label: 'Geographical Area',
      // colSpan:
      //   screenSize?.toString()?.toLowerCase() === 'mobile' ? 1 : 2,
      text: `${fireQuote?.district}`,

    }:null,
  ]?.filter((d) => d);

  return (
    <>
      <Text
        type={'title'}
        className={`w-full flex ${
          screenType?.toString()?.toLowerCase() === 'mobile'
            ? 'flex-wrap'
            : ''
        } -mb-2 items-center space-x-2`}
        severity={'info'}
      >
        <Text
          type={'title'}
          className={`flex ${
            screenType?.toString()?.toLowerCase() !== 'mobile'
              ? 'whitespace-nowrap'
              : ''
          }`}
        >
          Customer Details
        </Text>
        {role?.toString()?.toLowerCase() !== 'underwriter' ?
        <Text className={'flex items-center h-full w-full'}>
          {isQuoteReadOnly ? (
            <Text
              type={'label'}
              className={
                'quanta_link flex flex-col justify-center items-center -mb-0.5'
              }
              onClick={(_) => {
                goToStep(0);
                if (valuesAdditionalTabDetails) {
                  updateFireQuote({
                    currentTab: 0,
                    tabDetails: {
                      ...fireQuote?.tabDetails,
                      additionalTabDetails: {
                        ...fireQuote?.tabDetails
                          ?.additionalTabDetails,
                        underwriterComment:
                          valuesAdditionalTabDetails?.underwriterComment,
                      },
                    },
                  });
                }
              }}
            >
              View Details
            </Text>
          ) : (
            <Button
              flat
              type={'button'}
              className={`w-16 max-h-8`}
              size={'small'}
              onClick={(e) => {
                goToStep(0);
                updateFireQuote({
                  currentTab: 0,
                  tabDetails: {
                    ...fireQuote?.tabDetails,
                    additionalTabDetails: valuesAdditionalTabDetails
                      ? {
                          warranties: {
                            defaultWarranties:
                              getDefaultWarranties?.map(
                                (warranty) =>
                                  warranty?.warrantyShortDescription,
                              )
                                ? getDefaultWarranties?.map(
                                    (warranty) =>
                                      warranty?.warrantyShortDescription,
                                  )
                                : [],
                            userDefinedWarranties:
                              valuesAdditionalTabDetails?.userDefinedWarranties
                                ?.filter((udw) => udw?.warranty)
                                ?.map((udw) => {
                                  return udw?.warranty;
                                })
                                ? valuesAdditionalTabDetails?.userDefinedWarranties
                                    ?.filter((udw) => udw?.warranty)
                                    ?.map((udw) => {
                                      return udw?.warranty;
                                    })
                                : [],
                          },
                          exclusions: {
                            defaultExclusions:
                              getDefaultExclusions?.map(
                                (exclusion) =>
                                  exclusion?.exclusionShortDescription,
                              )
                                ? getDefaultExclusions?.map(
                                    (exclusion) =>
                                      exclusion?.exclusionShortDescription,
                                  )
                                : [],
                            userDefinedExclusions:
                              valuesAdditionalTabDetails?.userDefinedExclusions
                                ?.filter((ude) => ude?.exclusion)
                                ?.map((ude) => {
                                  return ude?.exclusion;
                                })
                                ? valuesAdditionalTabDetails?.userDefinedExclusions
                                    ?.filter((ude) => ude?.exclusion)
                                    ?.map((ude) => {
                                      return ude?.exclusion;
                                    })
                                : [],
                          },
                          clauses: {
                            defaultClauses: getDefaultClauses?.map(
                              (clause) => clause?.clauseDescription,
                            )
                              ? getDefaultClauses?.map(
                                  (clause) =>
                                    clause?.clauseDescription,
                                )
                              : [],
                            userDefinedClauses:
                              valuesAdditionalTabDetails?.userDefinedClauses
                                ?.filter((udc) => udc?.clause)
                                ?.map((udc) => {
                                  return udc?.clause;
                                })
                                ? valuesAdditionalTabDetails?.userDefinedClauses
                                    ?.filter((udc) => udc?.clause)
                                    ?.map((udc) => {
                                      return udc?.clause;
                                    })
                                : [],
                          },
                          conditions: {
                            defaultConditions:
                              getDefaultConditions?.map(
                                (condition) =>
                                  condition?.conditionShortDescription,
                              )
                                ? getDefaultConditions?.map(
                                    (condition) =>
                                      condition?.conditionShortDescription,
                                  )
                                : [],
                            userDefinedConditions:
                              valuesAdditionalTabDetails?.userDefinedConditions
                                ?.filter((udc) => udc?.condition)
                                ?.map((udc) => {
                                  return udc?.condition;
                                })
                                ? valuesAdditionalTabDetails?.userDefinedConditions
                                    ?.filter((udc) => udc?.condition)
                                    ?.map((udc) => {
                                      return udc?.condition;
                                    })
                                : [],
                          },
                          underwriterComment:
                            valuesAdditionalTabDetails?.underwriterComment
                              ? valuesAdditionalTabDetails?.underwriterComment
                              : '',
                        }
                      : fireQuote?.tabDetails?.additionalTabDetails,
                    riskLocationTabDetails: {
                      ...fireQuote?.tabDetails
                        ?.riskLocationTabDetails,
                      nonFloaterType:
                        fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
                          ?.toString()
                          ?.toLowerCase() !== 'floater'
                          ? values
                            ? values?.riskLocations
                            : fireQuote?.tabDetails
                                ?.riskLocationTabDetails
                                ?.nonFloaterType
                          : fireQuote?.tabDetails
                              ?.riskLocationTabDetails
                              ?.nonFloaterType,
                      floaterType:
                        fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
                          ?.toString()
                          ?.toLowerCase() === 'floater'
                          ? values
                            ? values
                            : fireQuote?.tabDetails
                                ?.riskLocationTabDetails?.floaterType
                          : fireQuote?.tabDetails
                              ?.riskLocationTabDetails?.floaterType,
                    },
                  },
                });
                if (valuesAdditionalTabDetails) {
                  updateFireQuoteUploadDocsVar({
                    documentDetails:
                      valuesAdditionalTabDetails?.documentDetails,
                  });
                } else if (fireQuoteUploadDocs) {
                  updateFireQuoteUploadDocsVar({
                    documentDetails:
                      fireQuoteUploadDocs?.documentDetails,
                  });
                }
              }}
              disabled={changeDisabled || loadingPremium}
            >
              Change
            </Button>
          )}
        </Text> :''}
      </Text>
      <Text>
        <DataGrid
          data={customerSummaryData}
          flow="cols"
          repeat={repeat}
          gapX={6}
          textType="normal"
          gapY={4}
          spaceY={2}
          nullData={() => (
            <Text severity={'neutral'}>Not Captured</Text>
          )}
        />
      </Text>
    </>
  );
}
